var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3615",
    "data-name": "Rectangle 3615",
    width: 30,
    height: 30,
    rx: 5,
    fill: "#dd2944"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2371",
    "data-name": "Trac\\xE9 2371",
    d: "M4.88-5.8H1v4.12H-1.01V-5.8H-4.87V-7.63h3.86v-4.1H1v4.1H4.88Z",
    transform: "translate(15 21.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAddIcon);
export default __webpack_public_path__ + "static/media/redAddIcon.ac9b115cec89aeb4c714928dfb399f7e.svg";
export { ForwardRef as ReactComponent };